export default {
      id: "softline-usage",
      viewBox: "0 0 100 36",
      url: "assets/" + "sprite.svg#softline-usage",
      toString: function () {
        return this.url;
      }
    }